import React from 'react';
import { LinkContainer} from 'react-router-bootstrap';
import { Container, Divider, Grid, Header, Image, List, Segment } from 'semantic-ui-react';
import logo from '../../images/favicon1.jpeg';

import './style.css';


class Footer extends React.Component {
  render() {
    return <Segment className='Footer' vertical style={{
      margin: '5em 0em 0em', padding: '5em 0em',   background: 'rgba(255, 255, 255, .9)'
     }}>
        <Container textAlign='center'>
          <Grid divided stackable>
            <Grid.Column width={4}>
            </Grid.Column>
            <Grid.Column width={4}>
              <Header  as='h4' content='Meet Us' />
              <List link >
                <LinkContainer to='/aboutus'>
                  <List.Item>Our Organization</List.Item>
                </LinkContainer>
                <LinkContainer to='/team'>
                  <List.Item>Management Team</List.Item>
                </LinkContainer>
                <LinkContainer to='/experts'>
                  <List.Item>Council of Experts</List.Item>
                </LinkContainer>

                <LinkContainer to='/capitalstructure'>
                  <List.Item>Capital Structure</List.Item>
                </LinkContainer>
              </List>
            </Grid.Column>
            <Grid.Column width={4}>
              <Header  as='h4' content='Our Friends' />
              <List link >
                <LinkContainer to='/science'>
                  <List.Item>Hong Kong Science Park</List.Item>
                </LinkContainer>
                <LinkContainer to='/collab'>
                  <List.Item>Scientific Collaborations</List.Item>
                </LinkContainer>
                <LinkContainer to='/expertise'>
                  <List.Item>Scientific Expertise & Capabilities</List.Item>
                </LinkContainer>
                <LinkContainer to='/smartcity'>
                <List.Item>Smart City Major Projects Partner</List.Item>
                </LinkContainer>
              </List>
            </Grid.Column>
            <Grid.Column width={4}>
            </Grid.Column>
          </Grid>

          <Divider section />
          <Image centered size='mini' src={logo}/>
          <List horizontal  divided link size='small'>
            <LinkContainer to='/contactus'>
              <List.Item>
                Contact Us
              </List.Item>
            </LinkContainer>
          </List>
        </Container>
      </Segment>;
  }
}

export default Footer;

// <LinkContainer to='/board'>
//   <List.Item>Board of Directors</List.Item>
// </LinkContainer>
